import React, { useContext, type JSX } from 'react';
import { IRapportInfo } from '../../../Types/RapportInfoType';
import { IDelsystem } from '../../../Features/Delsystem/_Common/Const/Delsystem';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';

export interface IRapporterProps {
  delsystem: IDelsystem;
  dbName?: string;
  children: (availableRapporter: IRapportInfo[]) => JSX.Element;
}

const AvailableRapporterInDelsystem: React.FunctionComponent<
  IRapporterProps
> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  if (!activeDatabaseContext.availableDelsystem) {
    return props.children([]);
  }

  return props.children(
    props.delsystem.rapporter.filter(
      rapport => activeDatabaseContext.availableRoutines?.[rapport.rutinID]
    )
  );
};

export default AvailableRapporterInDelsystem;
